import styled from 'styled-components';
import { Icon } from '~components';

export const Logo = styled(Icon).attrs({ icon: 'logo_round' })`
  svg {
    font-size: 38px;
  }
`;
